// ?> project links and images //

const project = [
  {
    Name: "Rad5 Tech Hub",
    Description:
      "Managed the website for Rad5 Tech Hub, Ensured the website's smooth operation by regularly updating content, fixing bugs, and performing routine maintenance.",
    Stack: "JavaScript, Bootstrap,Css, HTML",
    img: "/img/rad5.png",
    url: "https://academy.rad5.com.ng/",
  },
  {
    Name: "IG Hub",
    Description:
      "Innovation Growth Hub is a dynamic tech and business incubation hub that collaborates with startups at various stages. During my tenure, I managed their website, contributing to the digital presence and functionality of the hub.",
    Stack: "JavaScript, Bootstrap,Css,HTML",
    img: "/img/ighub.png",
    url: "https://ighub.ng/",
  },

  {
    Name: "Formcraft",
    Description:
      "FormCraft is a powerful and user-friendly online tool that empowers individuals and businesses to effortlessly create stunning landing pages and online profiles. With its intuitive interface,",
    Stack: "JavaScript, Bootstrap,React,PHP,Nestjs",
    img: "/img/formcraft.PNG",
    url: "https://formcraft.netlify.app/",
  },
  {
    Name: "Octavalidate",
    Description:
      "As part of my ongoing commitment to improving user experiences in web development, I contributed to an NPM package designed to enhance form validation in React JS applications. This package streamlines the process of validating frontend forms by leveraging a combination of validation rules, sophisticated regular expressions, and form input attributes.",
    Stack: "JavaScript, Bootstrap,React",
    img: "/img/octa.png",
    url: "https://www.npmjs.com/package/octavalidate-reactjs",
  },
  {
    Name: "sql-functions-kit",
    Description:
      "I developed a versatile and lightweight npm package that provides essential SQL functions for Node.js applications. This package simplifies SQL operations, making it easier for developers to interact with databases and perform common tasks efficiently. Whether you're building a small project or a large-scale application, this package offers a robust solution for your SQL needs.",
    Stack: "JavaScript, Node.js",
    img: "/img/sql.png",
    url: "https://www.npmjs.com/package/sql-functions-kit",
  },
];

export default project;
